// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"cc628201","192":"cc628201","333":"44995f14","383":"d9244ab4","419":"97d1286d","427":"cc628201","454":"cc628201"}[chunkId] + ".css";
};